"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const env_config_1 = __importDefault(require("../../env.config"));
exports.SsoWrapper = styled_components_1.default.div `
    --white:#fff;
    --black:#000;
    --blue :#0061fe;
    --lightBlue :#D5E9FB;
    --blueHover :#1565c0;
    --orange:#f39c12;
    --orangeHover:#c9861a;
    --green:#86b820;
    --gray:#f2f2f7;
    --gray2:#979592;
    --darkGray:#595959;
    --lightGray:#f7f7fd;
    --red:#f00;
    --bronze:#d2ad8e;
    --silver:#a3a3a3;
    --gold:#edba1d;
    --shop:#65ca99;
    --bundle:#f1be48;
    --elas:#204b70;
    --turbo:#ff3951;
    --credit:#6577ca;
    --premium:#ffa001;
    --bumpup:#0e91f9;
    --wa:#25D366;
    --fb:#4267b2;
    --twitter:#78cdf0;
    --email:#47c1c1;
    --copy:#646464;
    --sms:#323050;
    --phone:#039be5;
    --yellow:#FECE00;
  .whiteColor {color:var(--white)}
  .whiteBg,.whiteBtn,.grayBorderBtn{background-color:var(--white)}
  .yellowBg{background-color:var(--yellow)}
  .blackColor,.whiteBtn.blackColor,.whiteBtn-2.blackColor{color:var(--black)}
  .blackBg{background-color:var(--black)}
  .grayColor{color:var(--gray)}
  .gray2Color{color:var(--gray2)}
  .darkGrayColor{color:var(--darkGray)}
  .grayBg,.grayHoverBg:hover{background-color:var(--gray)}
  .blueBorder{border:1px solid var(--blue)}
  .darkGrayBg,.grayBtn{background-color:var(--darkGray)}
  .lightGrayColor{color:var(--lightGray)}
  .lightGrayBg,.lightGrayBtn{background-color:var(--lightGray)}
  .blueColor, a,.linkColor,.blueHoverText:hover{color:var(--blue)}
  .blueBg,.blueHoverBg:hover,.blueBtn{background-color:var(--blue)}
  .lightBlueBg{background-color:var(--lightBlue)}
  .blueBg:hover,.blueBtn:hover{background-color:var(--blueHover)}
  .orangeColor{color:var(--orange)}
  .orangeBg,.orangeBtn{background-color:var(--orange)}
  .orangeBg:hover,.orangeBtn:hover{background-color:var(--orangeHover)}
  .greenBg,.greenBtn{background-color:var(--green)}
  .greenColor{color:var(--green)}
  .redColor{color:var(--red)}
  .redBg{background-color:var(--red)}
  .waColor{color:var(--wa)}
  .waBg,.waBtn{background-color:var(--wa)}
  .fbColor{color:var(--fb)}
  .fbBg,.fbBtn{background-color:var(--fb)}
  .twitterColor{color:var(--twitter)}
  .twitterBg{background-color:var(--twitter)}
  .emailColor{color:var(--email)}
  .emailBg{background-color:var(--email)}
  .copyColor{color:var(--copy)}
  .copyBg{background-color:var(--copy)}
  .smsColor{color:var(--sms)}
  .smsBg{background-color:var(--sms)}
  .phoneColor{color:var(--phone)}
  .phoneBg{background-color:var(--phone)}
  .blueHoverBg:hover > svg path{fill:#fff}
  .blueHoverBg:hover{color:#fff}
  [class*="HoverBg"]{transition: 0.1s}
  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased
  }
  body {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth
  }
  *, body, ul, ol, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }
  body, button, h1, h2, h3, input, select, td, textarea, th{
    font-size: 16px;
    text-rendering: optimizeLegibility;
    line-height:100%
  }
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: transparent
  }
  * {direction: ${({ theme: { direction } }) => direction}}
  *[class*="-root"]{font-family: "Vazirmatn", sans-serif !important}
  .normalFont {font-weight: normal}
  a,.linkColor {
    text-decoration: none;
    outline: 0
  }
  a:hover {text-decoration: none}
  .noClick {pointer-events: none !important}
  a:hover, input[type="submit"]:hover, input[type="button"]:hover, button:hover,.pointer {cursor: pointer}
  .noSelection{
    -webkit-user-select:none;
    -webkit-touch-callout:none;
  }
  .pointer{z-index: 1}
  input[type="submit"], input[type="button"], button,[class*="Btn"]{
    border-radius:8px;
    text-align: center;
    border:0;
  }
  input[type="submit"]:not(.noRipple), input[type="button"]:not(.noRipple), button:not(.noRipple),[class*="Btn"]:not(.noRipple),.ripple{
    position:relative;
    overflow:hidden;
    transform: translate3d(0,0,0);
  }
  input[type="search"]::-webkit-search-cancel-button {
    filter: grayscale(100%);
    cursor: pointer;
    position: relative;
    ${({ theme: { isRTL } }) => isRTL ? "left:8px" : "right:8px"}
  }
  .boxShadow{ box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16)}
  .boxShadow2{ box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);}
  .btnShadow{box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)}
  .fullShadow{box-shadow:0 2px 16px rgba(190, 196, 209, 0.40)}
  input[type="submit"]:not(.noRipple):after, input[type="button"]:not(.noRipple):after, button:not(.noRipple):after,[class*="Btn"]:not(.noRipple):after,.ripple:after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(circle,#000 10%,transparent 10.01%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10);
    opacity: 0;
    transition: transform .2s,opacity 1s;
  }
  input[type="submit"]:active:after, input[type="button"]:active:after, button:active:after,[class*="Btn"]:active:after,.ripple:active:after{
    transform:scale(0, 0);
    opacity:0.2;
    transition:0s
  }
  .orangeBtn,.greenBtn,.grayBtn,.blueBtn,.whiteBtn-3,.whiteBtn,.whiteBtn-2,.fbBtn,.waBtn {
    color: #fff;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
    width:100%
  }
  .orangeBtn,.greenBtn,.grayBtn,.blueBtn,.fbBtn,.waBtn{border:1px solid transparent}
  .whiteBtn,.whiteBtn-2{
    color: #0061FE;
    background-color: #fff;
  }
  .whiteBtn{border: 2px solid #0061FE}
  .whiteBtn{border: 2px solid #0061FE}
  .whiteBtn-2{border: 1px solid #dcdcdc}
  .whiteBtn-3{
    border:2px solid #57585A;
    color:#000;
    background-color: var(--white);
  }
  .whiteBtn svg path{fill:#0061FE}
  .whiteBtn:hover{background-color:#f6fafd}
  .disabled,.disabledText,button:disabled {
    color: #737373 !important;
    pointer-events: none !important;
    border: 1px solid transparent;
  }
  .disabled,button:disabled {
    box-shadow: none;
    background-color: #979592 !important;
  }
  button:disabled svg path:not(:last-child),button:disabled svg path:only-child,.disabled svg path:not(:last-child),.disabled svg path:only-child {
    color:#737373 !important;
    fill:#737373 !important
  }
  *.disabled,*:disabled{cursor:not-allowed !important}
  input:disabled{-webkit-text-fill-color: #979592 !important}
  input:-webkit-autofill {-webkit-box-shadow: 0 0 0 1000px white inset}
  ul {list-style: none}
  ul, ol {list-style-position: inside}
  .listTypeDisc {list-style-type: disc}
  p{line-height: 1.5em}
  img {
    max-width: 100%;
    object-fit: cover
  }
  .noImgFit {object-fit:unset}
  button, fieldset, img,input {
    border: 0;
    background-color: transparent;
    outline: 0;
  }
  svg {overflow: visible}
  svg[data-flip-top="true"]{transform: scaleY(-1)}
  ${({ theme: { isLTR } }) => isLTR && ` svg[data-flip="true"] {transform: scaleX(-1)}`}
  ${({ theme: { isMobile } }) => isMobile && `.mobileCardBorder{border-bottom: 8px solid var(--gray)}`}
  select, textarea, button, input[type=submit], input[type=button] {
    appearance: none;
    outline: 0
  }
  input:focus, textarea:focus {outline: 0}
  ::-webkit-input-placeholder {color: #57585a}
  ::-moz-placeholder {color: #57585a}
  :-ms-input-placeholder {color: #57585a}
  .ta-s{text-align: ${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}}
  .ta-e{text-align: ${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}}
  .float-s{float:${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}}
  .float-e{float:${({ theme: { isRTL } }) => (isRTL ? "left" : "right")}}
  .clear {clear: both}
  .center {text-align: center}
  .m-0 {margin: 0}
  .m-auto {margin: auto}
  .ms-auto {margin-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: auto}
  .me-auto {margin-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: auto}
  .contentVisibilityHidden{content-visibility: hidden}
  .pageMoved .contentVisibilityHidden{content-visibility: unset}
  .overflowHidden {overflow: hidden}
  .overflowVisible {overflow: visible}
  .overflowHidden-x,.ssr {overflow-x: hidden}
  .overflowX-scroll {overflow-x: scroll}
  .overflowY-scroll {overflow-y: scroll}
  .overflowX-scroll,.overflowY-scroll{scroll-behavior: smooth}
  section,.block {display: block}
  .hide{display:none}
  .forceHide{display:none !important}
  .inline {display: inline-block}
  .underline{text-decoration:underline}
  .italic{font-style:italic}
  .lineThrough{text-decoration:line-through}
  .bold {font-weight: bold}
  .fullRadius{border-radius:100%}
  .radius-8{border-radius:8px}
  .radius-0,[class*="Btn"].radius-0{border-radius:0}
  .ltr{direction:ltr}
  .breakWord{word-break:break-word}
  .breakAll{word-break:break-all}
  .wrap{white-space:normal}
  .noWrap{white-space:nowrap}
  .flex{display:flex}
  .flexWrap{flex-wrap:wrap}
  .flexNoWrap{flex-wrap:nowrap}
  .flex-1{flex:1}
  .flexRow{flex-flow:row wrap}
  .alignSelfCenter{align-self:center}
  .alignSelfStart{align-self:flex-start}
  .justifyContent{justify-content:center}
  .alignItems{align-items: center}
  .flexSpaceBetween{justify-content:space-between}
  .flexSpaceAround{justify-content:space-around}
  .spaceEvenly{justify-content:space-evenly}
  .flexDirectionColumn{flex-direction:column}
  .flexDirectionRow{flex-direction:row}
  .flexDirectionRowReverse{flex-direction:row-reverse}
  .flexDirectionColumnReverse{flex-direction:column-reverse}
  .flexEnd{justify-content:end}
  .table{
    display:table;
    width:100%
  }
  .equalTable{table-layout:fixed}
  .tableCell{
    display:table-cell;
    vertical-align:middle
  }
  .tableRow{
    display:table-row;
    border-collapse:collapse
  }
  .vTop{vertical-align:top}
  .vMiddle{vertical-align:middle}
  .vBottom{vertical-align:bottom}
  .vTextTop{vertical-align:text-top}
  .vSub{vertical-align:sub}
  .vSup{vertical-align:super}
  .relative {position: relative}
  .absolute {position: absolute}
  .fixed{
    position:fixed;
    position:-ms-device-fixed;
    -webkit-backface-visibility:hidden;
    backface-visibility:hidden
  }
  .bottom-0{
    bottom:0;
    left:0;
    z-index:1;
    overflow: hidden;
  }
  .sticky{
    position:-webkit-sticky;
    position:sticky;
    top:0;
    z-index:2
  }
  .trim {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width:90%
  }
  .trimTwoLines {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4em;
  }
  .centerPosition {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto
  }
  .centerPosition1{
    position:absolute;
    top:50%;
    left:50%;
    transform:translateX(-50%) translateY(-50%)
  }
  .width-fit{width:fit-content}
  .width-1200{width:1200px}
  .width-700{width:700px}
  .width-460{
  width:460px;
  margin:auto
  }
  .width-100{width:100%}
  .width-20{width:20%}
  .width-25{width:25%}
  .width-30{width:30%}
  .width-33{width:33%}
  .width-40{width:40%}
  .width-50{width:50%}
  .width-70{width:70%}
  .width-75{width:75%}
  .width-90{width:90%}
  .width-auto{width:auto}
  .width-100vw{width:100vw}
  &.fullScreenHeight,.height-100{height:100%}
  .height-100vh{height:100vh}
  .height-auto{height:auto}
  .height-55{height:55px}
  .height-50{height:50px}
  .mt-auto {margin-top:auto}
  .mb-auto {margin-bottom: auto}
  .ms-auto {margin-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: auto}
  .me-auto {margin-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: auto}
  .ms-8 {margin-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 8px}
  .me-8 {margin-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 8px}
  .ms-16 {margin-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 16px}
  .me-16 {margin-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 16px}
  ${({ theme: { isDesktop, isRTL } }) => isDesktop && `.ms-32 {margin-${isRTL ? "right" : "left"}: 32px}`}
  ${({ theme: { isDesktop, isRTL } }) => isDesktop && `.me-32 {margin-${isRTL ? "left" : "right"}: 32px}`}
  .mt-8{margin-top:8px !important}
  .mb-8{margin-bottom:8px !important}
  .mt-16{margin-top:16px !important}
  .mb-16{margin-bottom:16px !important}
  .mt-32{margin-top:32px}
  .mb-32{margin-bottom:32px}
  .ps-8 {padding-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 8px !important}
  .pe-8 {padding-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 8px !important}
  .ps-16 {padding-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 16px}
  .pe-16 {padding-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 16px}
  .ps-32 {padding-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 32px}
  .pe-32 {padding-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 32px}
  .p-8{padding:8px !important}
  .p-16{padding:16px !important}
  .p-20{padding:20px !important}
  .p-32{padding:32px !important}
  .pt-8{padding-top: 8px !important}
  .pb-8{padding-bottom: 8px !important}
  .pt-16{padding-top: 16px !important}
  .pb-16{padding-bottom: 16px !important}
  .pt-32{padding-top:32px !important}
  .pb-32{padding-bottom:32px !important}
  .p-0{padding:0}
  .pt-0{padding-top: 0 !important}
  .pb-0{padding-bottom: 0 !important}
  .ps-0{padding-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}: 0 !important}
  .pe-0{padding-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}: 0 !important}
  .border{border:1px solid #dcdcdc !important}
  .borderBlack{border:1px solid #000}
  .borderTop{border-top:1px solid #dcdcdc}
  .borderBottom{border-bottom:1px solid #dcdcdc}
  .borderBottomDashed{border-bottom:1px dashed #dcdcdc}
  .borderBottomLightGray{border-bottom : 1px solid #F2F2F7}
  .borderTopLightGray{border-top : 1px solid #F2F2F7}
  .borderLightGray{border : 1px solid #F2F2F7}
  .border-s{border-${({ theme: { isRTL } }) => isRTL ? "right" : "left"}:1px solid #dcdcdc}
  .border-e{border-${({ theme: { isRTL } }) => isRTL ? "left" : "right"}:1px solid #dcdcdc}
  .border-0,hr,[class*="Btn"].border-0{border:none}
  .font-12{font-size:0.75em}
  .font-13{font-size:0.8125em}
  .font-14{font-size:0.875em}
  .font-15{font-size:0.938em}
  .font-16{font-size:1em}
  .font-17{
    font-size:1.0625em;
    line-height:1.1625em
  }
  .font-18{
    font-size:1.125em;
    line-height:1.150em
  }
  .font-19{
    font-size:1.1875em;
    line-height:1.1875em
  }
  .font-20{
    font-size:1.250em;
    line-height:1.250em
  }
  .font-21{
    font-size:1.3125em;
    line-height:1.3125em
  }
  .font-22{
    font-size:1.375em;
    line-height:1.4em
  }
  .font-23{
    font-size:1.3750em;
    line-height:1.3750em
  }
  .font-24{
    font-size:1.5em;
    line-height:1.5em;
  }
  .font-26{
    font-size:1.62em;
    line-height:1.5em;
  }
  .font-30{
    font-size:1.875em;
    line-height:1.89em;
  }
  .font-32{
    font-size:2em;
    line-height:2em;
  }
  .font-36{
    font-size:2.25em;
    line-height:1.5em;
  }
  .font-40{
    font-size:2.5em;
    line-height:1.5em;
  }
  .gap-5{gap: 5px !important}
  .gap-10{gap: 10px !important}
  .gap-15{gap: 15px !important}
  .gap-20{gap: 20px !important}
  .gap-25{gap: 25px !important}
  .gap-30{gap: 30px !important}
  .gap-40{gap: 40px !important}
  /* arabic */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE80-FEFC;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* arabic */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE80-FEFC;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Vazirmatn';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${env_config_1.default.FONT_PATH}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  * {
    font-family: "Vazirmatn", sans-serif;
  }
  .shimmerEffect {
    animation: shimmer 2.5s infinite linear;
    background: linear-gradient(to right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
    background-size: 1000px 100%;
    transition: 0.3s;
  }
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }
`;
